<!--
  nzOffsetTop causes problem when clickin on a link to scroll to the specific part of the page,
  it scrolls to incorrect possition. nzTargetOffset works correctly.
-->
<nz-anchor
  nzAffix="false"
  [nzBounds]="boundingArea"
  [nzTargetOffset]="offsetTop">
  <ul>
    <li
      class="option"
      *ngFor="let item of navigationItems">
      <ui-icon
        key="check"
        *ngIf="isLeadingIconVisible"
        [class.hidden]="!item.complete"></ui-icon>
      <nz-link
        [nzHref]="item.id"
        [nzTitle]="item.translationName | transloco"></nz-link>
    </li>
  </ul>
</nz-anchor>
